import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { GiHouse } from "react-icons/gi";
import { RiMenu5Line } from "react-icons/ri";
import { SiAboutdotme } from "react-icons/si";
import { RiProfileLine } from "react-icons/ri";
import { MdContactPage } from "react-icons/md";
import { AiFillGithub } from "react-icons/ai";
import { AiFillLinkedin } from "react-icons/ai";
import { IoMdArrowDropupCircle } from "react-icons/io";
import { AiOutlineClose } from "react-icons/ai";

const Navigation = ({ setToggle }) => {
  const handleToggleOff = () => {
    setToggle(false);
  };

  return (
    <Container>
      <div className="menu-heading">
        <h2>MENU</h2>

        <code>
          <i> Hover on button to display menu content</i>
        </code>
      </div>
      <div className="close-menu" onClick={handleToggleOff}>
        <AiOutlineClose />
      </div>
      <div className="circular-menu">
        <div className="inner-circle">
          <div className="circle-animation">
            <RiMenu5Line />
          </div>
        </div>

        <div>
          <NavLink to="/" className={`panel`} onClick={handleToggleOff}>
            <GiHouse />
          </NavLink>
          <NavLink to="/about" className="panel" onClick={handleToggleOff}>
            <SiAboutdotme />
          </NavLink>
          <NavLink to="/projects" className="panel" onClick={handleToggleOff}>
            <RiProfileLine />
          </NavLink>
          <NavLink to="/contact" className="panel" onClick={handleToggleOff}>
            <MdContactPage />
          </NavLink>
          <a
            href="https://github.com/damaluku"
            target="_blank"
            rel="noreferrer"
            className="panel"
          >
            <AiFillGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/damian-aluku-59b06023a"
            target="_blank"
            rel="noreferrer"
            className="panel"
          >
            <AiFillLinkedin />
          </a>
        </div>
      </div>

      <a href="#secTop">
        <MYIoMdArrowDropupCircle />
      </a>
    </Container>
  );
};

export default Navigation;

const Container = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  z-index: 5;
  width: 100%;
  min-height: 100vh;
  background-color: rgba(225, 225, 225, 0.5);
  background-color: #f2f2f2;
  /* background-color: ${({ theme }) => theme.dark.text}; */
  background-image: url("https://images.unsplash.com/photo-1524146128017-b9dd0bfd2778?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;

  .menu-heading {
    text-transform: uppercase;
    position: absolute;
    top: 4rem;
    text-align: center;
    color: ${({ theme }) => theme.dark.primary};

    h2 {
      font-size: 3rem;
    }
  }

  .circular-menu {
    position: relative;
    font-size: 18px;
    border-radius: 50%;
  }

  .inner-circle {
    content: "";
    background: #000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 4em;
    height: 4em;
    border-radius: 50%;
    z-index: 1;
    box-shadow: 0 0 1em rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .inner-circle svg {
    color: ${(props) => props.theme.dark.custom};
    font-size: 1.3em;
    cursor: pointer;
  }

  .circle-animation {
    display: grid;
    place-content: center;
    width: 4em;
    height: 4em;
    border-radius: 50%;
    animation-name: button-pulse;
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;

    @keyframes button-pulse {
      0% {
        border: none;
      }
      25% {
        border: 2px solid ${(props) => props.theme.dark.custom};
      }
      50% {
        border: 4px solid ${(props) => props.theme.dark.primary};
      }
      75% {
        border: 2px solid ${(props) => props.theme.dark.custom};
      }
      100% {
        border: none;
      }
    }
  }

  .close-menu {
    position: absolute;
    top: 2rem;
    right: 2rem;
    z-index: 1;
    color: ${(props) => props.theme.light.text};
    font-size: 2rem;
    cursor: pointer;

    animation-name: close-pulse;
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;

    @keyframes close-pulse {
      0% {
        color: ${(props) => props.theme.light.custom};
      }

      30% {
        color: ${(props) => props.theme.light.text};
      }
      60% {
        color: ${(props) => props.theme.light.custom};
      }

      100% {
        color: ${(props) => props.theme.light.text};
      }
    }
  }

  .panel {
    background: rgba(0, 0, 0, 0.5);
    text-decoration: none;
    width: 11.7em;
    height: 10em;
    position: absolute;
    top: 50%;
    left: 50%;
    color: ${(props) => props.theme.dark.custom};
    transform-origin: top center;
    transition: width 0.1s, height 0.1s, opacity 0.1s;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    backdrop-filter: blur(4px);
    opacity: 0;
    width: 0;
    height: 0;
  }

  .panel:nth-child(1) {
    transform: translateX(-50%);
  }

  .panel:nth-child(1) svg {
    transform: translateX(-50%);
  }

  .panel:nth-child(2) {
    transition-delay: 0.1s;
    transform: translateX(-50%) rotate(60deg);
  }

  .panel:nth-child(2) svg {
    transform: translateX(-50%) rotate(-60deg);
  }

  .panel:nth-child(3) {
    transition-delay: 0.2s;
    transform: translateX(-50%) rotate(120deg);
  }

  .panel:nth-child(3) svg {
    transform: translateX(-50%) rotate(-120deg);
  }

  .panel:nth-child(4) {
    transition-delay: 0.3s;
    transform: translateX(-50%) rotate(180deg);
  }

  .panel:nth-child(4) svg {
    transform: translateX(-50%) rotate(-180deg);
  }

  .panel:nth-child(5) {
    transition-delay: 0.4s;
    transform: translateX(-50%) rotate(240deg);
  }

  .panel:nth-child(5) svg {
    transform: translateX(-50%) rotate(-240deg);
  }

  .panel:nth-child(6) {
    transition-delay: 0.5s;
    transform: translateX(-50%) rotate(300deg);
  }

  .panel:nth-child(6) svg {
    transform: translateX(-50%) rotate(-300deg);
  }

  .panel:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  .panel svg {
    font-size: 2.5em;
    position: absolute;
    top: 50%;
    left: 50%;
  }

  .circular-menu:hover .panel {
    opacity: 1;
    height: 10em;
    width: 11.7em;
  }

  .active {
    background: rgba(0, 0, 0, 1);
  }
`;

const MYIoMdArrowDropupCircle = styled(IoMdArrowDropupCircle)`
  font-size: 2rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  color: ${(props) => props.theme.dark.custom};
  transition: transform 0.3s;

  :hover {
    transform: scale(1.2);
  }
`;
